import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import ModalContainer from '@components/modals/ModalContainer';
import { toastError, toastSuccess } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { inviteSupplier } from '@services/supplierService';

const InviteTeamMember = ({ onClose }) => {
	const [email, setEmail] = useState('');
	const [inviteLink, setInviteLink] = useState('');
	const dispatch = useDispatch();

	const handleSubmit = async () => {
		try {
			dispatch(openLoader());
			const data = await inviteSupplier({ email });
			setInviteLink(data.payload);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const onAddToClipBoard = () => {
		navigator.clipboard
			.writeText(inviteLink)
			.then(() => {
				toastSuccess('Copied successfully');
			})
			.catch(() => {
				toastError('Something went wrong!');
			});
	};

	return (
		<ModalContainer onCloseModal={onClose}>
			<div className="common-popup invite-team-modal">
				<div className="common-popup-header d-flex align-items-center justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Invite Team Member</h3>
					</div>
					<div>
						{inviteLink && (
							<div className="copy-link cursor-pointer pt-1 pr-5" onClick={onAddToClipBoard}>
								<p className="regular-12 gray_dark-03 active">Copy link</p>
							</div>
						)}
						<div className="close-btn d-flex " onClick={onClose}>
							<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
						</div>
					</div>
				</div>
				<div className="common-popup-body">
					<div className="invite-team-form">
						<div className="row">
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="collection">Team Member</label>
									<input
										type="text"
										placeholder="Enter a email"
										value={email}
										onChange={(e) => setEmail(e.target.value)}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onClose}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={handleSubmit} disabled={email === ''}>
							Invite
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default InviteTeamMember;
